import { useEffect, useRef } from 'react';
import { useAuth } from '../AuthContext';
import { getStoredToken } from '../utils/auth';

const AuthInterceptor = () => {
  const { logout } = useAuth();
  const logoutRef = useRef(logout);

  useEffect(() => {
    logoutRef.current = logout;
  }, [logout]);

  useEffect(() => {
    const originalFetch = window.fetch;

    window.fetch = async (input, init = {}) => {
      // 1. Prepare request URL string
      const url = typeof input === 'string' ? input : input instanceof Request ? input.url : '';

      // 2. Auto-inject Authorization header if missing or malformed
      const token = getStoredToken();
      let modifiedInit = { ...init };

      if (token) {
        let headers = new Headers(init.headers || (input instanceof Request ? input.headers : {}));
        const existingAuth = headers.get('Authorization') || headers.get('authorization');
        
        if (!existingAuth || existingAuth === 'Bearer null' || existingAuth === 'Bearer undefined' || existingAuth.trim() === 'Bearer') {
          headers.set('Authorization', `Bearer ${token}`);
          modifiedInit.headers = headers;
        }
      }

      try {
        const response = await originalFetch(input, modifiedInit);

        // 3. Handle 401 Unauthorized globally, excluding explicit auth endpoints
        if (response.status === 401) {
          const isPublicAuthEndpoint = (
            url.includes('/auth/login') ||
            url.includes('/auth/forgot-password') ||
            url.includes('/auth/reset-password')
          );

          if (!isPublicAuthEndpoint) {
            console.warn(`[AuthInterceptor] 401 Unauthorized sur ${url}. Déconnexion de la session.`);
            logoutRef.current();
          }
        }

        return response;
      } catch (error) {
        throw error;
      }
    };

    return () => {
      window.fetch = originalFetch;
    };
  }, []);

  return null;
};

export default AuthInterceptor;
